export default "__VITE_ASSET__BDeFXjWs__"